/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Contract_DescriptionInputs */



/**
* | output |
* | --- |
* | "A fixed number of seats for a fixed term, with a prepaid usage budget, against a signed order." |
*
* @param {Partner_Add_Contract_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_description = /** @type {((inputs?: Partner_Add_Contract_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine feste Anzahl Plätze für eine feste Laufzeit, mit vorausbezahltem Nutzungsbudget, gegen eine unterschriebene Bestellung.")
	return /** @type {LocalizedString} */ ("A fixed number of seats for a fixed term, with a prepaid usage budget, against a signed order.")
});